export default "/images/vendor/flag-icon-css/flags/1x1/kr.svg?9408e6924b5f440610a071e119c64ce4";